import { Suspense, lazy } from 'react'
import { Navigate, RouteObject } from 'react-router-dom'

import { IPublicClientApplication } from '@azure/msal-browser'
import { ProgressBar } from 'primereact/progressbar'

import Layout from './components/layout'
import { ProviderLayout } from './components/layout/ProviderLayout'

// Views
const PageNotFoundView = lazy(() => import('./views/404'))

const HomeView = lazy(() => import('./views/home'))

const ProjectDetailsView = lazy(() => import('./views/projects/details'))
const ProjectMembersView = lazy(() => import('./views/projects/ProjectMembersView'))
const ProjectServicesView = lazy(() => import('./views/projects/ProjectServicesView'))
const CustomPropertiesView = lazy(() => import('./views/projects/PropertiesView'))
const ProjectJsonView = lazy(() => import('./views/projects/ProjectJsonView'))
const ProjectFilesView = lazy(() => import('./views/projects/ProjectFilesView'))

const SettingsAdaptersView = lazy(() => import('./views/settings/adapters'))
const SettingsMembersView = lazy(() => import('./views/settings/members'))
const SettingsCustomizationView = lazy(() => import('./views/settings/customization'))
const SettingsTemplatesView = lazy(() => import('./views/settings/templates'))
const SettingsGlobalParametersView = lazy(() => import('./views/settings/globalparameters'))
const SettingsApiKeysView = lazy(() => import('./views/settings/apikey'))
const SettingsTenantFilesView = lazy(() => import('./views/settings/tenantfiles'))
const SettingsTenantServicesListView = lazy(() => import('./views/settings/tenantservices'))
// const SettingsAppConfigView = lazy(() => import('./views/settings/app-config'))
const SettingsConfigTransferView = lazy(() => import('./views/settings/config-transfer'))

const TenantSelectionView = lazy(() => import('./views/tenants/selection'))

export function createRoutes(publicClientApplication: IPublicClientApplication): RouteObject {
  return {
    element: <ProviderLayout publicClientApplication={publicClientApplication} />,
    children: [
      {
        path: '/',
        element: (
          <Suspense fallback={<ProgressBar mode="indeterminate" />}>
            <Layout />
          </Suspense>
        ),
        children: [
          {
            path: '/',
            element: <HomeView />,
          },
          {
            path: '/projects/:id',
            children: [
              {
                index: true,
                element: <Navigate to="details" replace />,
              },
              {
                path: 'details',
                element: <ProjectDetailsView />,
              },
              {
                path: 'forms',
                element: <PageNotFoundView />,
              },
              {
                path: 'members',
                element: <ProjectMembersView />,
              },
              {
                path: 'stats',
                element: <PageNotFoundView />,
              },
              {
                path: 'logs',
                element: <PageNotFoundView />,
              },
              {
                path: 'services',
                element: <ProjectServicesView />,
              },
              {
                path: 'properties',
                element: <CustomPropertiesView />,
              },
              {
                path: 'json',
                element: <ProjectJsonView />,
              },
              {
                path: 'files',
                element: <ProjectFilesView />,
              },
            ],
          },
          {
            path: '/settings',
            children: [
              {
                index: true,
                element: <Navigate to="adapters" replace />,
              },
              {
                path: 'app-config',
                element: <PageNotFoundView />,
              },
              {
                path: 'adapters',
                element: <SettingsAdaptersView />,
              },
              {
                path: 'members',
                element: <SettingsMembersView />,
              },
              {
                path: 'customize',
                element: <SettingsCustomizationView />,
              },
              {
                path: 'templates',
                element: <SettingsTemplatesView />,
              },
              {
                path: 'globalparameters',
                element: <SettingsGlobalParametersView />,
              },
              {
                path: 'apikeys',
                element: <SettingsApiKeysView />,
              },
              {
                path: 'tenantfiles',
                element: <SettingsTenantFilesView />,
              },
              {
                path: 'services',
                element: <SettingsTenantServicesListView />,
              },
              {
                path: 'config-transfer',
                element: <SettingsConfigTransferView />,
              },
            ],
          },
          {
            path: '/tenants/switch',
            element: <TenantSelectionView />,
          },
          { path: '404', element: <PageNotFoundView /> },
          { path: '*', element: <Navigate to="/404" /> },
        ],
      },
    ],
  }
}
